import React from 'react';
import PropTypes from 'prop-types';

const Link = ({ to, children, className, separateTab }) => {
    const enhancedProps = separateTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};
    return (
        <a href={to} className={className} {...enhancedProps}>
            {children}
        </a>
    );
};

Link.propTypes = {
    to: PropTypes.string,
    className: PropTypes.string,
    separateTab: PropTypes.bool,
};

export default Link;
